import {useCallback} from 'react';

import styled from 'styled-components';

import {attachModal} from '~/shared/components/ReduxModal';
import {headingXS} from '~/shared/theme/typography';
import {media} from '~/shared/theme/media';
import {getLocalizationService} from '~/shared/services/localisationService';
import AddCreditCard from '~/shared/components/AddCreditCard';
import {AddCreditCardModes} from '~/shared/consts/checkoutConsts';
import {trackEvent} from '~/shared/services/analytics';

import {PieCloseModalButton} from '../../styled';

const Root = styled.div`
  position: relative;
  ${media.minLargeMobile`
    width: auto;
    max-width: 500px;
  `}

  &:first-child {
    overflow-y: hidden;
    background-color: ${({theme}) => theme.colors.surface};
    width: calc(100vw - 32px);
  }
`;

const Header = styled.p`
  ${headingXS}
  color: ${({theme}) => theme.colors.charcoal80};
  padding: 16px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  text-align: center;
`;

type AddPaymentMethodModalProps = {
  closeModal: () => void;
  args: {
    onSuccess?: () => void;
    AddCreditCardComponent: typeof AddCreditCard;
    pageSource?: string;
  };
};

export const AddPaymentMethodModal = ({closeModal, args: {AddCreditCardComponent, pageSource, onSuccess}}: AddPaymentMethodModalProps) => {
  const {t} = getLocalizationService();
  const onSuccessHandler = useCallback(() => {
    if (onSuccess) {
      onSuccess();
    }
    trackEvent('addPaymentMethod_successful', {
      linkType: 'credit_card',
      pageSource,
    });
    closeModal();
  }, [pageSource, onSuccess, closeModal]);

  return (
    <Root>
      <Header id="modal-title">
        {t('add_a_payment_method')}
      </Header>
      <PieCloseModalButton onClick={closeModal} />
      <AddCreditCardComponent
        mode={AddCreditCardModes.MINIMAL}
        onSuccess={onSuccessHandler}
        minimalWrapper
      />
    </Root>
  );
};

AddPaymentMethodModal.hideCloseButton = true;
attachModal('addPaymentMethodModal', AddPaymentMethodModal);
